<template>
  <div>
    <v-row dense no-gutters>
      <v-col md="12">
        <v-card>
          <v-card-title>
            Buscar
            <v-spacer></v-spacer>
            <autocompletar v-model="buscado"></autocompletar>
            <v-spacer></v-spacer>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col md="12" v-if="buscado">
        <h2>Datos</h2>
        <v-card color="primary">
          <v-card-text>
            <v-col md="12">
              <MostrarDatos :beneficiario="buscado"></MostrarDatos>
            </v-col>
            <v-col md="8" offset-md="2" v-if="buscado">
              <v-card color="teal">
                <v-card-text>
                  <v-card>
                    <v-card-text>
                      <v-row dense>
                        <v-col md="12" v-if="buscado">
                          <h2>Patologias</h2>
                          <Patologias
                            @baja="baja"
                            v-for="patologia in buscado.PatologiasBeneficiarios"
                            :key="patologia.id"
                            :PatologiaBeneficiario="patologia"
                          ></Patologias>
                        </v-col>
                        <v-col md="12" v-if="buscado">
                          <h3>Nueva Patologia</h3>
                          <Patologias
                            @alta="alta"
                            v-if="buscado"
                            :PatologiaBeneficiario="nuevapatologia"
                          ></Patologias>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-card-text>
              </v-card>
            </v-col>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Autocompletar from "@/components/Beneficiarios/AutoNombreDNINroAfi";
import Patologias from "@/components/Patologias/ABM";
import MostrarDatos from "@/components/Beneficiarios/MostrarDatos";
export default {
  components: { Patologias, Autocompletar, MostrarDatos },
  data() {
    return {
      buscado: undefined,
    };
  },
  computed: {
    nuevapatologia() {
      if (this.buscado) {
        return { id: 0, id_afiliado: this.buscado.id_afiliado };
      } else {
        return { id: 0, id_afiliado: 0 };
      }
    },
  },
  methods: {
    alta(patologia) {
      this.buscado.PatologiasBeneficiarios.push(patologia);
    },
    baja(id) {
      this.buscado.PatologiasBeneficiarios = this.buscado.PatologiasBeneficiarios.filter(
        (pat) => pat.id_patologia != id
      );
    },
  },
};
</script>

<style></style>
